
define(
	'NVT.anuualupdateform.anuualupdateform'
,   [
		'NVT.anuualupdateform.anuualupdateform.View',

		'Utils'
	]
,   function (
		MyOrganisationView,

		Utils
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */

			var layout = container.getComponent('Layout');

			if (layout) {
					layout.on('afterShowContent', function() {		
					var layoutDisplayed = window.location.href.indexOf("sbfannualupdateform") != -1;
					if (layoutDisplayed == true) {
						jQuery("#site-header").remove();
						jQuery("#site-footer").remove();
					}					
			  	});
			}
			
			var pageType = container.getComponent('PageType');
				pageType.registerPageType({
				name: 'customanuualupdateform',
				routes: ['sbfannualupdateform'],
				view: MyOrganisationView,
				defaultTemplate: {
					name: 'nvt_anuualupdateform_myorganisation.tpl',
					displayName: 'Annual Update Form',
					// thumbnail: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/default-layout-profile.png')
				}
			});			
			
			var MyAccountMenu = container.getComponent('Application');
            if(MyAccountMenu)
            {
                MyAccountMenu.getComponent().renderHeader();
            }			
		}
	};
});
